import qs from 'query-string';
import { instance } from 'api/api';

export const commandMenuAPI = {
    async getRecentContent(): Promise<any> {
        const url = `/data/command-menu/recent-content`;
        const response = await instance.get(url);
        return response?.data?.data ?? [];
    },
    saveRecentContent(data: any) {
        const url = `/data/command-menu/recent-content`;
        return instance.post(url, data);
    },
};
